/* eslint-disable no-undef */

import React, {PureComponent} from 'react'
import {withStyles} from '@material-ui/core/styles/index'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import {Box, Button, Grid} from '@material-ui/core'
import Terms from './Terms'
import {withTranslation} from 'react-i18next'

const styles = theme => ({
    root: {
        //marginTop: theme.spacing(2),
        margin: '0 ' + -theme.spacing(1) * 2 + 'px',
        width: 'calc(100% + ' + theme.spacing(4) + 'px)',
        ...(!theme.isMobile && {
            marginTop: theme.spacing(6),
            margin: '0 ' + -theme.spacing(1) * 4 + 'px',
            width: 'calc(100% + ' + theme.spacing(8) + 'px)'
        })
    },
    container: {
        padding: '0 ' + theme.spacing(2) + 'px',
        ...(!theme.isMobile && {
            padding: '0 ' + theme.spacing(4) + 'px'
        }),
        paddingBottom: theme.spacing(0.5),
        alignItems: 'center'
    },
    buttons: {
        display: 'block'
        //justifyContent: 'flex-end',
        /*...theme.isMobile && {
            position: 'absolute',
            left: 0,
            bottom: 0,
        },*/
    },
    backButton: {
        display: 'block',
        margin: 'auto',
        marginLeft: 0,
        padding: '10px 4px 10px 0px',
        color: theme.backButton ? theme.backButton.color : 'rgba(0, 0, 0, 0.5)',
        width: theme.backButton ? theme.backButton.width : null,
        marginTop: -8,
        marginBottom: -8,
        maxWidth: theme.backButton ? theme.backButton.maxWidth : null,
        ...(!theme.isMobile && {
            padding: '10px 10px 10px 0px',
            marginTop: 0,
            marginBottom: 0
        }),
        borderRadius: theme.borderRadius ? theme.backButton.borderRadius : 10,
        textTransform: theme.forwardButton ? theme.forwardButton.textTransform : null
    },
    twoButtonsBackButton: {
        //marginLeft: theme.spacing.unit * 2,
        ...(!theme.isMobile &&
            {
                //marginLeft: theme.spacing.unit * 4,
            })
    },
    forwardButton: {
        display: 'block',
        margin: 'auto',
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0,
        padding: '8px 20px',
        ...(!theme.isMobile && {
            padding: '8px 28px',
            marginTop: theme.forwardButton ? theme.forwardButton.marginTop : 0,
            marginBottom: theme.forwardButton ? theme.forwardButton.marginBottom : theme.spacing(2)
        }),
        boxShadow: theme.forwardButton ? theme.forwardButton.boxShadow : null,
        color: theme.forwardButton ? theme.forwardButton.color : null,
        borderRadius: theme.forwardButton ? theme.forwardButton.borderRadius : null,
        width: theme.forwardButton ? theme.forwardButton.width : null,
        maxWidth: theme.forwardButton ? theme.forwardButton.maxWidth : null,
        background: theme.forwardButton ? theme.forwardButton.background : null,
        textTransform: theme.forwardButton ? theme.forwardButton.textTransform : null,
        ...(theme.isMobile && {
            width: '100%!important'
        })
    },
    rightIcon: {
        marginLeft: theme.spacing(1),
        marginRight: -theme.spacing(1) * 0.5,
        minWidth: 20,
        ...(theme.isMobile && {
            display: 'none'
        })
    },
    progressBarWrapper: {
        margin: theme.spacing(3, 0, 1.5, 0),
        background: '#e7e7e7'
    },
    progressBar: {
        background: theme.palette.secondaryColor + '!important',
        height: 10
    }
})

class QuestionPageNavigation extends PureComponent {
    render() {
        const {classes, questionPage, isLoading, activeStep, next, prev, theme, t} = this.props

        const isFirstStep = questionPage && questionPage.stepper && questionPage.stepper.firstStep
        const showBackButton = questionPage && questionPage.showBackButton === true && !isFirstStep
        const showForwardButton =
            questionPage &&
            questionPage.submitButton.show &&
            questionPage.submitButton.position === 'below' &&
            questionPage.submitButton.label !== 'hidden'

        const showButtons = showBackButton || showForwardButton

        const hidePrevButton = questionPage?.id === 156 || questionPage?.id === 159 || questionPage?.id === 161 || questionPage?.id === 165 || questionPage?.id === 166 || questionPage?.id === 171 || questionPage?.id === 172

        return (
            <div className={'app-question-page-id-' + questionPage?.id + '-footer ' + classes.root + ' QuestionPageNavigation'}>
                {questionPage && questionPage.stepper && (
                    <div className={classes.progressBarWrapper + ' progressBarWrapper'}>
                        <div
                            className={classes.progressBar}
                            style={{ width: (questionPage.stepper.step / questionPage.stepper.max) * 100 + '%' }}
                        ></div>
                    </div>
                )}
                {showButtons && (
                    <Grid container className={classes.container}>
                        {!isFirstStep && !hidePrevButton && (
                            <Grid item xs={5} sm={6} className={classes.buttons} key={'button1'}>
                                {showBackButton && (
                                    <Button
                                        onClick={prev}
                                        disabled={activeStep === 0}
                                        className={
                                            classes.backButton +
                                            ' backButton ' +
                                            (questionPage.submitButton.show && questionPage.submitButton.position === 'below'
                                                ? classes.twoButtonsBackButton
                                                : null)
                                        }
                                    >
                                        <FontAwesomeIcon
                                            className={classes.rightIcon}
                                            size="lg"
                                            style={{ marginRight: 4 }}
                                            icon={['far', 'angle-left']}
                                        />{' '}
                                        {t('Takaisin')}
                                    </Button>
                                )}
                            </Grid>
                        )}
                        <Grid item xs={isFirstStep || hidePrevButton ? 12 : 7} sm={isFirstStep || hidePrevButton ? 12 : 6} key={'button2'}>
                            {showForwardButton && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    className={classes.forwardButton + ' forwardButton'}
                                    onClick={next}
                                    disabled={isLoading}
                                >
                                    {questionPage.submitButton.label}
                                    {!isLoading && (
                                        <FontAwesomeIcon className={classes.rightIcon} size="lg" icon={['far', questionPage.submitButton.icon]} />
                                    )}
                                    {isLoading && <FontAwesomeIcon className={classes.rightIcon} size="lg" icon={['far', 'spinner-third']} spin />}
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                )}
                {questionPage && questionPage.termsPosition === 'inside' && questionPage.stepper && questionPage.stepper.firstStep && (
                    <Box mt={showButtons ? 0.75 : 0} className={'Terms-wrapper'}>
                        <Terms theme={theme} />
                    </Box>
                )}
            </div>
        )
    }
}

export default withTranslation()(withStyles(styles)(QuestionPageNavigation))
